import moment from "moment";

export const convertTo12HourFormat = (time: string): string => {
    // Check if the input is a time-only string (HH:mm or H:mm format)
    const timeOnlyRegex = /^(\d{1,2}):(\d{2})$/;
    const match = time.match(timeOnlyRegex);
    
    if (match) {
        // Handle time-only format (e.g., "14:30" -> "02:30 pm")
        const hours = parseInt(match[1], 10);
        const minutes = parseInt(match[2], 10);
        
        // Create a moment object with today's date and the given time
        const momentTime = moment().hours(hours).minutes(minutes);
        return momentTime.format('hh:mm a');
    }
    
    // Handle full date strings (existing behavior)
    return moment(time).format('hh:mm a');
};

export const convertTo24HourFormat = (time: string): string => {
    return moment(time, "HH:mm a").format('HH:mm');
};